import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import TextAlign from '@tiptap/extension-text-align';

export type DefaultExtension =
  | ReturnType<typeof StarterKit.configure>
  | ReturnType<typeof Image.configure>
  | ReturnType<typeof TextAlign.configure>;

export type KnownAction =
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strike'
  | 'bulletList'
  | 'orderedList'
  | 'blockquote'
  | 'codeBlock'
  | 'undo'
  | 'redo'
  | 'unsetLink'
  | 'setParagraph'
  | 'toggleHeading';

export type Level = 1 | 2 | 3 | 4 | 5 | 6;

export interface ActionPayloads {
  heading: number;
  setLink: string;
  setImage: string;
  toggleHeading: { level: number };
}

export const defaultExtensions: DefaultExtension[] = [
  StarterKit.configure({
    bulletList: {
      HTMLAttributes: {
        class: 'tw-list-disc tw-pl-4 tw-my-2',
      },
    },
    orderedList: {
      HTMLAttributes: {
        class: 'tw-list-decimal tw-pl-4 tw-my-2',
      },
    },
    blockquote: {
      HTMLAttributes: {
        class: 'tw-border-l-4 tw-border-gray-300 tw-pl-4 tw-my-2 tw-italic',
      },
    },
    codeBlock: {
      HTMLAttributes: {
        class: 'tw-bg-gray-100 tw-p-4 tw-rounded tw-my-2',
      },
    },
    link: {
      openOnClick: false,
      HTMLAttributes: {
        class: 'tw-text-blue-500 tw-underline hover:tw-text-blue-700',
      },
    },
    underline: {
      HTMLAttributes: {
        class: 'tw-underline',
      },
    },
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
    alignments: ['left', 'center', 'right'],
    defaultAlignment: undefined,
  }),
];
